import { Paperclip } from "lucide-react";
import type { AttachmentNote } from "@/components/atomic-crm/types";
import { useStorageSrc } from "./useStorageSrc";

const stop = (e: React.MouseEvent) => e.stopPropagation();

export const SignedImageAttachment = ({
  attachment,
}: {
  attachment: AttachmentNote;
}) => {
  const src = useStorageSrc(attachment);
  if (!src)
    return (
      <span
        className="block h-[100px] w-[200px] border border-border bg-muted"
        aria-busy="true"
        title={attachment.title}
      />
    );
  return (
    <a
      href={src}
      title={attachment.title}
      target="_blank"
      rel="noopener noreferrer"
      className="block"
      onClick={stop}
    >
      <img
        src={src}
        alt={attachment.title}
        className="h-[100px] w-[200px] cursor-pointer border border-border object-cover object-left"
      />
    </a>
  );
};

export const SignedFileAttachment = ({
  attachment,
}: {
  attachment: AttachmentNote;
}) => {
  const src = useStorageSrc(attachment);
  return (
    <div className="flex items-center gap-2">
      <Paperclip className="h-4 w-4" />
      {src ? (
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:no-underline"
          onClick={stop}
        >
          {attachment.title}
        </a>
      ) : (
        <span className="text-muted-foreground">{attachment.title}</span>
      )}
    </div>
  );
};
